import { useState } from 'react';

const faqs = [
  {
    q: 'galagame 是什么？',
    a: 'galagame 是一个综合性游戏平台，提供丰富的游戏内容、极致的游戏体验与高额奖励。平台汇聚了超过500款精品游戏，涵盖动作射击、角色扮演、策略竞技、休闲益智、体育竞速等多种类型，致力于为每一位玩家打造专属的游戏乐园。',
  },
  {
    q: '如何注册 galagame 账号？',
    a: '注册 galagame 账号非常简单。访问 galagame 官网，点击右上角的"立即注册"按钮，使用手机号或邮箱完成验证即可。新用户注册即可获得价值50元的新手礼包，包含游戏道具和专属福利。',
  },
  {
    q: 'galagame 支持哪些平台？',
    a: 'galagame 支持 Windows、macOS、iOS 和 Android 全平台。你可以在官网下载对应平台的客户端，也可以通过网页版直接体验部分游戏。galagame 云游戏技术让你在不同设备间无缝切换，随时随地畅享游戏乐趣。',
  },
  {
    q: 'galagame 的游戏需要付费吗？',
    a: 'galagame 平台上的游戏分为免费游戏和付费游戏两类。免费游戏可以直接下载体验，付费游戏支持单次购买或会员订阅制。开通 galagame 会员还可以享受专属折扣和每月免费游戏库。',
  },
  {
    q: 'galagame 有哪些奖励机制？',
    a: 'galagame 拥有丰富的奖励体系，包括每日签到奖励、赛季通行证、竞技排行榜奖金、邀请好友奖励、限时活动奖励等。玩家可以通过参与平台活动获得现金、游戏道具、限定皮肤和实物周边等丰厚奖品。',
  },
  {
    q: '如何参加 galagame 的电竞赛事？',
    a: 'galagame 定期举办各类电竞赛事，涵盖多款热门竞技游戏。玩家可以通过游戏内报名通道或 galagame 官网赛事页面报名参加。赛事设有丰厚的奖金池，晋级选手还有机会受邀参加线下决赛。',
  },
  {
    q: 'galagame 如何保障账号安全？',
    a: 'galagame 采用银行级加密技术保护用户数据，支持双重认证（2FA）、设备管理和AI风险识别系统。建议所有玩家开启双重认证功能，定期修改密码，不要在第三方平台泄露账号信息。如遇安全问题，可随时联系 galagame 7x24小时客服。',
  },
  {
    q: 'galagame 客服联系方式是什么？',
    a: 'galagame 提供7x24小时在线客服支持。你可以通过官网在线客服、官方邮箱 support@galagame.com 或官方社群渠道联系我们。会员用户还可享受专属客服通道，获得更快速的问题响应。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            关于 galagame 的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="font-heading text-sm font-semibold text-foreground-100 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-[500px] pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}